export default "__VITE_ASSET__D4zB3EZf__"